/**
 * Utility functions for file chunking and chunked uploads
 */

export interface ChunkInfo {
  chunkNumber: number;
  totalChunks: number;
  chunk: Blob;
  fileName: string;
  fileSize: number;
}

/**
 * Splits a file into chunks of specified size
 * @param file - The file to split into chunks
 * @param chunkSize - Size of each chunk in bytes (default: 20MB)
 * @returns Array of chunk information
 */
export const splitFileIntoChunks = (
  file: File,
  chunkSize: number = 10 * 1024 * 1024 // 20MB in bytes
): ChunkInfo[] => {
  const chunks: ChunkInfo[] = [];
  const totalChunks = Math.ceil(file.size / chunkSize);

  for (let i = 0; i < totalChunks; i++) {
    const start = i * chunkSize;
    const end = Math.min(start + chunkSize, file.size);
    const chunk = file.slice(start, end);

    chunks.push({
      chunkNumber: i + 1, // Start from 1
      totalChunks,
      chunk,
      fileName: file.name,
      fileSize: file.size,
    });
  }

  return chunks;
};

export const convertObjectToFormData = (videoData: any) => {
  const formData = new FormData();
  Object.entries(videoData).forEach(([key, value]) => {
    if (value !== null && value !== undefined && key !== "file") {
      formData.append(key, value.toString() || "0");
    }
  });
  return formData;
};

/**
 * Creates FormData for a single chunk upload
 * @param chunkInfo - Information about the chunk
 * @param additionalData - Additional form data to include
 * @returns FormData object ready for upload
 */
export const createChunkFormData = (
  chunkInfo: ChunkInfo,
  videoData: Record<string, any> = {}
): FormData => {
  const formData = new FormData();
  console.log("chunkInfo", chunkInfo.chunk);

  // Add chunk-specific data
  formData.append("chunkNumber", chunkInfo.chunkNumber.toString());
  formData.append("totalChunks", chunkInfo.totalChunks.toString());
  formData.append("chunk", chunkInfo.chunk);

  // Add additional data
  Object.entries(videoData).forEach(([key, value]) => {
    if (value !== null && value !== undefined && key !== "file") {
      formData.append(key, value.toString() || "0");
    }
  });

  return formData;
};

/**
 * Calculates upload progress percentage
 * @param currentChunk - Current chunk number (1-based)
 * @param totalChunks - Total number of chunks
 * @returns Progress percentage (0-100)
 */
export const calculateUploadProgress = (
  currentChunk: number,
  totalChunks: number
): number => {
  return Math.round((currentChunk / totalChunks) * 100);
};
